import ProfileHomePage from '@/modules/home/ProfileHomePage';
import Loading from '@/shared/components/Carregando';
import Links from '@/shared/constants/navegacao';
import MyContext from '@/shared/contexts/AppContext';
import { ehPerfilEstagiario } from '@/modules/business/attendance-sheet/presentation/pages/perMonth/perMonthFilters.utils';
import { buildMovimentacoesPendentesEnviadasHref } from '@/shared/navigation/navigation-movimentacoes-links.utils';
import { useNavigationView } from '@/shared/hooks/useNavigationView';
import { isLogedIn } from '@/modules/system/auth/application/auth.service';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useContext, useMemo } from 'react';

function hasMovimentacoesHomeParams(searchParams: URLSearchParams): boolean {
  return (
    searchParams.has('referenciaI') ||
    searchParams.has('referenciaF') ||
    searchParams.has('defensoriaId') ||
    searchParams.has('nucleoId') ||
    searchParams.has('defensorId')
  );
}

const HomeIndexPage = () => {
  const context = useContext(MyContext);
  const [searchParams] = useSearchParams();
  const { effectiveView, viewReady } = useNavigationView();
  const authVisao = context?.authVisao ?? null;

  const ehEstagiario = useMemo(
    () => ehPerfilEstagiario(authVisao, effectiveView),
    [authVisao, effectiveView],
  );

  const destinoPendentes = useMemo(() => {
    if (!hasMovimentacoesHomeParams(searchParams)) {
      return buildMovimentacoesPendentesEnviadasHref();
    }
    const query = searchParams.toString();
    return query
      ? `${Links.Atividades_Pendentes}?${query}`
      : Links.Atividades_Pendentes;
  }, [searchParams]);

  if (hasMovimentacoesHomeParams(searchParams)) {
    return <Navigate to={destinoPendentes} replace />;
  }

  if (isLogedIn() && !viewReady) {
    return <Loading />;
  }

  if (ehEstagiario) {
    return <Navigate to={Links.Estagiario_Folha_Atual} replace />;
  }

  return <ProfileHomePage />;
};

export default HomeIndexPage;
